var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.36762 27.8737C3.51796 29.8282 5.0214 31.482 7.12621 31.6323C10.1331 31.933 14.3427 32.0833 17.4999 32.0833C20.6571 32.0833 24.8668 31.933 27.8736 31.6323C28.926 31.6323 29.8281 31.1813 30.4295 30.4295C31.0308 29.6778 31.4819 28.9261 31.6322 27.8737C31.9329 24.8668 32.0833 20.6572 32.0833 17.5C32.0833 14.3428 31.7826 10.1332 31.6322 7.12629C31.4819 5.17182 29.9784 3.51804 27.8736 3.3677C24.8668 3.06701 20.6571 2.91667 17.4999 2.91667C14.3427 2.91667 10.1331 3.21735 7.12621 3.3677C5.17174 3.51804 3.51796 5.02148 3.36762 7.12629C3.06693 10.1332 2.91659 14.3428 2.91659 17.5C2.91659 20.6572 3.06693 24.8668 3.36762 27.8737ZM10.2834 17.5506L15.6958 10.7345C15.8461 10.4338 16.1468 10.2835 16.5979 10.2835C16.8985 10.2835 17.0489 10.4338 17.3496 10.5842C17.8006 11.0352 17.9509 11.6366 17.4999 12.0876L13.8917 16.2972L23.5137 16.2972C24.115 16.2972 24.7164 16.7483 24.7164 17.5C24.7164 18.2517 24.2654 18.7027 23.5137 18.7027L14.042 18.7027L17.6503 22.9124C18.1013 23.3634 17.951 24.1151 17.4999 24.4158C17.0489 24.8668 16.2972 24.7165 15.9965 24.2655L10.2834 17.5506Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e92cb26a88b81abb5f2995a7d0a73de4.svg";
export { ForwardRef as ReactComponent };